import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';
import {
    convertCartBasicInfoToAReadableFormat,
    convertCartItemsToAReadableFormat,
} from '../selectors/converterSelector';
import { getCartItem, getCurrentCartNotes } from '../selectors/cartSelector';
import { createAlert } from '../dom/window';
import { getTranslation } from '../lang/main';
import { currencyDisplay } from '../_utils';
import {
    clearCartUserInput,
    updateCartUserInput,
} from './cartUserInputActions';
import {
    getAdditionalProductsForCustomTag,
    getMarkingCode,
    getPrintOptionValue,
    getRelatedProducts,
    getSelectedMaleButtonProducts,
} from '../selectors/tagWizardSelector';
import { getTagData } from '../selectors/defaultSelectors';
import {
    exportSVGs,
    getExportedJSONData as getEditorExportedJSONData,
} from './editorActions';
import { getTagWizardExportedJSONData } from '../../../../../../public/resources/themes/leaderproducts.com-theme/js/src/main/actions/tagWizardActions';

let cartUpdateTimeout;

export const toggleLoading = (value) => {
    return {
        type: 'TOGGLE_CART_LOADING',
        value: value,
    };
};

export const toggleRowLoading = (key, value) => {
    return {
        type: 'TOGGLE_CART_ROW_LOADING',
        key: key,
        value: value,
    };
};
export const updateCartList = (list) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_CART_LIST',
            list: list,
        });

        dispatch(refreshCartTotalNumber());
    };
};
export const replaceCartList = (list) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'REPLACE_CART_LIST',
            list: list,
        });

        dispatch(refreshCartTotalNumber());
    };
};
export const updateQuantity = (id, qty) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_CART_QTY',
            key: id,
            quantity: qty,
        });
    };
};
export const finaliseQuantity = (id, qty) => {
    return (dispatch, getState) => {
        const state = getState();
        const cartItem = getCartItem(state, id);

        if (cartItem) {
            dispatch(updateQuantity(id, qty));

            clearTimeout(cartUpdateTimeout);
            cartUpdateTimeout = setTimeout(() => {
                dispatch(sendUpdateQuantity(id, qty));
            }, 500);
        }
    };
};
export const sendUpdateQuantity = (id, qty) => {
    return (dispatch, getState) => {
        const state = getState();
        const cartItem = getCartItem(state, id);
        const { MinOrderQuantity } = cartItem;

        if (qty >= MinOrderQuantity) {
            const payload = {
                ID: id,
                TotalUnitItems: qty,
            };

            dispatch(toggleRowLoading(id, true));

            return axiosUpdateCartQuantity(payload)
                .then((response) => {
                    dispatch(
                        processCartInformation(response, 'updateCartOrderItem')
                    );
                    dispatch(toggleRowLoading(id, false));
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    // Revert
                    dispatch({
                        type: 'UPDATE_CART_QTY',
                        key: id,
                        quantity: cartItem._TotalUnitItems,
                    });

                    dispatch(toggleRowLoading(id, false));
                });
        }
    };
};
export const updateCartDetail = (detail) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_CART_DETAIL',
            detail: detail,
        });

        dispatch(refreshCartTotalNumber());
    };
};
export const refreshCartTotalNumber = () => {
    return (dispatch, getState) => {
        const state = getState();
        const totalItems = Object.keys(state.cart.list).length || 0;
        const subtotal = state.cart.detail.SubTotal;
        const { currencyFormat, currencyDisplayCode, locale } = state.cart;

        // Update Total Items
        const $cartTotalItems = $('.cart-total-items');
        if ($cartTotalItems.length) {
            if ($cartTotalItems.html() != totalItems) {
                $cartTotalItems.text(totalItems);
                notifyCartUpdate();
            }
        }

        const $nextButton = $('#step2-button');
        if ($nextButton.length) {
            if (totalItems > 0) {
                $nextButton
                    .removeClass('button--disabled')
                    .attr('href', $nextButton.data('href'));
            } else {
                $nextButton
                    .addClass('button--disabled')
                    .attr('href', 'javascript:void(0)');
            }
        }

        // Update Subtotal
        const $cartSubTotal = $('.cart-subtotal-value');
        if ($cartSubTotal.length) {
            $cartSubTotal.text(
                currencyDisplay(
                    subtotal,
                    currencyDisplayCode,
                    currencyFormat,
                    locale
                )
            );
        }
    };
};
export const notifyCartUpdate = () => {
    const $cartTotalItems = $('.cart-total-items');
    if ($cartTotalItems.length) {
        $cartTotalItems.addClass('animated pulse scroll-active');

        setTimeout(() => {
            $cartTotalItems.removeClass('animated pulse scroll-active');
        }, 400);
    }
};
export const processCartInformation = (response, endpointKey) => {
    return (dispatch, getState) => {
        const detail = convertCartBasicInfoToAReadableFormat(
            response.data.data[endpointKey]
        );
        const list = convertCartItemsToAReadableFormat(
            response.data.data[endpointKey]
        );

        dispatch(replaceCartList(list));
        dispatch(updateCartDetail(detail));
    };
};

export const getCartData = (cart) => {
    const cartData = [];
    const selectedMaleButtonProducts = [];
    const arrayFilterList = cart.Items.edges.filter(
        ({ node }) => node?.ParentItem?.ID > 0
    );
    const arrayFilterListParent = cart?.Items.edges.filter(
        ({ node }) =>
            Object.keys(node?.ParentItem).length === 0 &&
            node?.Buyable?.OfficialType === null
    );
    const arrayFilterListParentOfficialType = cart?.Items.edges.filter(
        ({ node }) => node?.Buyable?.OfficialType === null
    );

    const excludedfilterArray = arrayFilterListParent.concat(
        arrayFilterListParentOfficialType.filter(
            (item) => arrayFilterListParent.indexOf(item) < 0
        )
    );
    console.log('constFilterArray==================', excludedfilterArray);
    console.log(
        'arrayFilterListParen=================',
        arrayFilterListParentOfficialType
    );
    console.log(
        'arrayFilterListParent=================',
        arrayFilterListParent
    );
    arrayFilterListParent.map((item) => {
        let temp = arrayFilterList?.filter(
            (element) => element?.node?.ParentItem?.ID === item?.node?.ID
        );
        let tempLimitOne = arrayFilterList?.find(
            (element) => element?.node?.ParentItem?.ID === item?.node?.ID
        );
        var relatedBuyables = '';
        if (temp.length === 1) {
            const selectedMaleButtonProductsSingle = [
                {
                    BuyableID: tempLimitOne?.node?.Buyable.ID,
                    TotalUnitItems: tempLimitOne?.node?.TotalUnitItems,
                },
            ];
            relatedBuyables = window.encodeJsonToBase64(
                JSON.stringify(selectedMaleButtonProductsSingle)
            );
        } else {
            temp.map((product) => {
                selectedMaleButtonProducts.push({
                    BuyableID: product?.node?.Buyable.ID,
                    TotalUnitItems: product?.node?.TotalUnitItems,
                });
            });
            relatedBuyables = window.encodeJsonToBase64(JSON.stringify(selectedMaleButtonProducts));
        }

        if (item?.node?.TagSummaryData) {
            cartData.push({
                BuyableID: item?.node?.Buyable?.ID,
                TotalUnitItems: item?.node?.TotalUnitItems,
                IsCustomTag: item?.node?.IsCustomTag,
                TagEditorData: item?.node?.TagEditorData,
                TagWizardData: item?.node?.TagWizardData,
                TagSummaryData: item?.node?.TagSummaryData,
                SVGPreviewFront: item?.node?.SVGPreviewFront,
                SVGPreviewBack: item?.node?.SVGPreviewBack,
                MarkingCodeFront: item?.node?.MarkingCodeFront,
                MarkingCodeBack: item?.node?.MarkingCodeBack,
                PrintOption: item?.node?.PrintOption,
                TagType: item?.node.TagType,
                ...(temp[0]?.node?.Buyable.ID && {
                    RelatedBuyables: relatedBuyables,
                }),
            });
        } else {
            cartData.push({
                BuyableID: item?.node?.Buyable?.ID,
                TotalUnitItems: item?.node?.TotalUnitItems,
            });
        }
    });
    return cartData;
};
export const requestCart = () => {
    return (dispatch, getState) => {
        if (getState().user.loggedIn) {
            dispatch(toggleLoading(true));

            return axiosRequestCart()
                .then((response) => {
                    dispatch(processCartInformation(response, 'readOneCart'));
                })
                .catch((response) => {
                    handleAxiosErrors(response);
                })
                .then(() => {
                    dispatch(toggleLoading(false));
                });
        }
    };
};

export const axiosRequestCart = () => {
    let { url, query } = config.cart.listing;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const addToCart = (
    payload,
    callback = {},
    showMessage = true,
    type = ''
) => {
    return (dispatch, getState) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosAddItemToCart(payload, type)
            .then((response) => {
                // Request cart again
                dispatch(requestCart());

                if (showMessage) {
                    createAlert(
                        {
                            message: getTranslation(
                                'CART.ADD_TO_CART.SUCCESS_MESSAGE'
                            ),
                        },
                        'success'
                    );
                }

                // Callbacks
                if (successCallback) successCallback();
                if (alwaysCallback) alwaysCallback();
            })
            .catch((error) => {
                handleAxiosErrors(error);

                // Callbacks
                if (errorCallback) errorCallback();
                if (alwaysCallback) alwaysCallback();
            });
    };
};

export const updateCartOrderItem = (payload) => {
    return (dispatch, getState) => {
        return axiosUpdateCart(payload)
            .then(() => {
                dispatch(requestCart());
            })
            .catch((error) => {
                handleAxiosErrors(error);
            });
    };
};

export const processCartGraphQLParams = (params) => {
    let graphQLParams = [];

    const requiredFields = {
        ID: {
            type: 'number',
        },
        BuyableID: {
            type: 'number',
        },
        TotalUnitItems: {
            type: 'number',
        },
        PICVerified: {
            type: 'boolean',
        },
        PICNumber: {
            type: 'string',
        },
        SequencePrefix: {
            type: 'string',
        },
        ContinueSequence: {
            type: 'boolean',
        },
        SequenceStartingNumber: {
            type: 'string',
        },
        IsCustomTag: {
            type: 'boolean',
        },
        TagWizardData: {
            type: 'string', // Do this so we don't put extra "
        },
        TagEditorData: {
            type: 'string',
        },
        TagSummaryData: {
            type: 'string',
        },
        RelatedBuyables: {
            type: 'string',
        },
        TagType: {
            type: 'number',
        },
        SVGPreviewFront: {
            type: 'string',
        },
        SVGPreviewBack: {
            type: 'string',
        },
        MarkingCodeFront: {
            type: 'string',
        },
        MarkingCodeBack: {
            type: 'string',
        },
        PrintOption: {
            type: 'number',
        },
        DuplicateTag: {
            type: 'boolean',
        },
        ParticipantCode: {
            type: 'string',
        },
        TagYear: {
            type: 'string',
        },
        VariationType: {
            type: 'string',
        },
        SequenceList: {
            type: 'string',
        },
    };

    Object.keys(requiredFields).forEach((requiredField) => {
        if (typeof params[requiredField] === 'undefined') {
            return;
        }

        if (requiredFields[requiredField]['type'] === 'string') {
            // remember to transfer string with double quote for BE graphQL
            graphQLParams.push(`${requiredField}: "${params[requiredField]}"`);
        } else {
            graphQLParams.push(`${requiredField}: ${params[requiredField]}`);
        }
    });

    console.log('Debug graphqlParams', graphQLParams);

    return graphQLParams;
};

export const axiosAddItemToCart = (params, type) => {
    let { url, query } = config.cart.addCustomTag;

    let data = {
        query: query,
        variables: {
            ...params,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosUpdateCartItemCustomTag = (params) => {
    let { url, query } = config.cart.updateCustomTag;

    let data = {
        query: query,
        variables: {
            ...params,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosUpdateCartQuantity = (params) => {
    let { url, query } = config.cart.update;
    query = query.replace(/{mutationParams}/, '');
    query = query.replace(
        /{params}/,
        `ID: ${params.ID}, TotalUnitItems: ${params.TotalUnitItems}`
    );

    return axios.post(
        url,
        { query: query },
        {
            withCredentials: true,
        }
    );
};
export const axiosUpdateCartNotes = (params) => {
    let { url, query } = config.cart.update;
    query = query.replace(/{mutationParams}/, `($Notes: String)`);
    query = query.replace(/{params}/, `ID: ${params.ID}, Notes: $Notes`);

    return axios.post(
        url,
        {
            query: query,
            variables: {
                Notes: params.Notes,
            },
        },
        {
            withCredentials: true,
        }
    );
};
export const axiosUpdateCart = (params) => {
    let { url, query } = config.cart.update;

    let graphQLParams = [];

    const requiredFields = {
        ID: {
            type: 'number',
        },
        TotalUnitItems: {
            type: 'number',
        },
        IsCustomTag: {
            type: 'boolean',
        },
        TagWizardData: {
            type: 'string', // Do this so we don't put extra "
        },
        TagEditorData: {
            type: 'string',
        },
    };

    Object.keys(requiredFields).forEach((requiredField) => {
        if (typeof params[requiredField] === 'undefined') {
            return;
        }

        if (requiredFields[requiredField]['type'] === 'string') {
            // remember to transfer string with double quote for BE graphQL
            graphQLParams.push(`${requiredField}: "${params[requiredField]}"`);
        } else {
            graphQLParams.push(`${requiredField}: ${params[requiredField]}`);
        }
    });

    query = query.replace(/{mutationParams}/, '');
    query = query.replace(/{params}/, `${graphQLParams.join(', ')}`);

    return axios.post(
        url,
        { query: query },
        {
            withCredentials: true,
        }
    );
};

export const removeItem = (item, callback = {}) => {
    return (dispatch, getState) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        const payload = {
            ID: Number(item.ID),
        };

        return axiosRemoveItemFromCart(payload)
            .then((response) => {
                // Request cart again
                dispatch(requestCart());

                // Callbacks
                if (successCallback) successCallback();
                if (alwaysCallback) alwaysCallback();
            })
            .catch((error) => {
                handleAxiosErrors(error);

                // Callbacks
                if (errorCallback) errorCallback();
                if (alwaysCallback) alwaysCallback();
            });
    };
};
export const axiosRemoveItemFromCart = (params) => {
    let { url, query } = config.cart.remove;

    return axios.post(
        url,
        { id: query, variables: params },
        {
            withCredentials: true,
        }
    );
};

export const updateNotes = (value) => {
    return (dispatch, getState) => {
        const state = getState();
        const { selectedCartNoteId } = state.cart;

        dispatch(updateCartUserInput(selectedCartNoteId, '__Notes', value));
    };
};

export const openNoteModal = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SELECT_EDIT_CART_NOTE',
            value: id,
        });

        // Toggle modal
        if ($('#cart-summary-notes-modal').length) {
            $('#cart-summary-notes-modal').modal('show');
        }
    };
};
export const saveNotes = (value) => {
    return (dispatch, getState) => {
        let state = getState();
        const id = state.cart.selectedCartNoteId;
        const notes = getCurrentCartNotes(state);

        const payload = {
            ID: id,
            Notes: notes,
        };

        dispatch(toggleRowLoading(id, true));

        return axiosUpdateCartNotes(payload)
            .then((response) => {
                // dispatch(processCartInformation(response, 'updateCartOrderItem'));
                dispatch(requestCart());

                // Toggle modal
                if ($('#cart-summary-notes-modal').length) {
                    $('#cart-summary-notes-modal').modal('hide');
                }
            })
            .catch((error) => {
                handleAxiosErrors(error);
            })
            .finally(() => {
                dispatch(clearCartUserInput(id, 'Notes'));
                dispatch(toggleRowLoading(id, false));
            });
    };
};
